import { render, staticRenderFns } from "./prices-history.vue?vue&type=template&id=5a2b13d1&"
import script from "./prices-history.vue?vue&type=script&lang=js&"
export * from "./prices-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports